import { render, staticRenderFns } from "./item-tab.vue?vue&type=template&id=64c8a9ee&scoped=true"
import script from "./item-tab.vue?vue&type=script&lang=js"
export * from "./item-tab.vue?vue&type=script&lang=js"
import style0 from "./item-tab.vue?vue&type=style&index=0&id=64c8a9ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_6szsw7whnsew6zajutnmcgkloi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c8a9ee",
  null
  
)

export default component.exports